import './CarsItem.css'

interface ICarsSectionProps {
    title: string
    subtitle: string
    color: string
    mobile: boolean
}

export default function CarsSectionHeader(props: ICarsSectionProps) {
    return <div style={{color: `${props.color}`}} className={`${props.mobile ? "Cars_section_header_mobile" : "Cars_section_header"}`}>
        <div
            className={`${props.mobile ? "Cars_section_header_title_mobile" : "Cars_section_header_title"}`}>{props.title}</div>
        <div className={`${props.mobile ? "Cars_section_header_subtitle_mobile" : "Cars_section_header_subtitle"}`}>{props.subtitle}</div>
    </div>
}